import { render, staticRenderFns } from "./CustomerEdit.vue?vue&type=template&id=46e3feb3"
import script from "./CustomerEdit.vue?vue&type=script&lang=ts"
export * from "./CustomerEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports